// extracted by mini-css-extract-plugin
module.exports = {"hidden-mobile":"WidgetWrapper_hidden-mobile__21dQE","hidden-tablet":"WidgetWrapper_hidden-tablet__3QHJ8","hidden-desktop":"WidgetWrapper_hidden-desktop__3gpgG"};